export enum HTTPCodes {
  LargePayload = 413,
  Unauthorized = 401,
  BadRequest = 400,
  Forbidden = 403,
  notFound = 404,
  ServerError = 500,
}
